import React from 'react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';

import { resetList } from 'fe-appdir-lib-utils';

const PROP_TYPES = {
  links: PropTypes.arrayOf(PropTypes.element),
  className: PropTypes.string.isRequired,
};
const DEFAULT_PROPS = {
  links: [],
};

const Nav = styled.nav`
  font-size: ${theme.fontSizeSm};
`;

const NavList = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  height: 100%;

  ${resetList};
`;

const NavItem = styled.li`
  font-weight: ${theme.fontWeightBold};
  margin: 0 ${theme.spacingMd};
  display: table;
  height: 100%;
`;

const NavLinkCss = css`
  text-decoration: none;
  color: ${theme.colorBase};
  position: relative;
  display: table-cell;
  vertical-align: middle;
  transition: color 0.2s ease-out;

  &::after {
    content: '';
    opacity: 0;
    border-width: 0 0 5px;
    border-style: solid;
    border-color: ${theme.colorBrandPrimary};
    display: block;
    position: absolute;
    padding-top: ${theme.spacingXs};
    left: 0;
    right: 0;
    transition: opacity 0.15s ease-out;
  }

  &:hover,
  &.is-active {
    color: ${theme.colorBrandPrimary};

    &::after {
      opacity: 1;
    }
  }
`;

const StyledNavLink = styled(NavLink)`
  ${NavLinkCss};
`;

const AppNav = ({ links, className }) => (
  <Nav className={className}>
    <NavList>
      {links.length &&
        links.map((link, i) => (
          <NavItem key={i}>
            <StyledNavLink {...link.props} component={link} />
          </NavItem>
        ))}
    </NavList>
  </Nav>
);

AppNav.propTypes = PROP_TYPES;
AppNav.defaultProps = DEFAULT_PROPS;

export default AppNav;
